import React, {
  forwardRef,
  type ReactNode,
  useCallback,
  useImperativeHandle,
} from 'react';
import useConstant from 'use-constant';
import ValidatorContext from './ValidatorContext';
import type {
  ValidatorContextValue,
  ValidatorFn,
  ValidatorWrapperHandlers,
} from './types';

interface Props {
  children: ReactNode;
}

const ValidatorWrapper = forwardRef<ValidatorWrapperHandlers, Props>(
  (props, ref) => {
    const map = useConstant<Map<symbol, ValidatorFn>>(() => new Map());
    const providerValue = useConstant<ValidatorContextValue>(() => ({
      addValidator: (id, fn) => {
        map.set(id, fn);
      },
      removeValidator: (id) => {
        map.delete(id);
      },
    }));
    const validityCheck = useCallback(() => {
      return [...map.values()].reduce((acc, fn) => fn() && acc, true);
    }, [map]);
    useImperativeHandle(ref, () => ({ validityCheck }));
    return (
      <ValidatorContext.Provider value={providerValue}>
        {props.children}
      </ValidatorContext.Provider>
    );
  }
);

export default ValidatorWrapper;
